<template>
  <div class="scene-overlay-wrapper">
    <canvas ref="canvas" id="portfolio-canvas"></canvas>
  </div>
</template>

<script>
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
// import vertex from './vertex.glsl';
// import fragment from './fragment.glsl';
import { EffectComposer } from "three/examples/jsm/postprocessing/EffectComposer.js";
import { RenderPass } from "three/examples/jsm/postprocessing/RenderPass.js";
import { UnrealBloomPass } from "three/examples/jsm/postprocessing/UnrealBloomPass.js";
// import textureImage from '@/assets/dust-texture-2.png';

export default {
  name: "ThreeBackground",
  props: {
    menuActive: Boolean,
  },
  data() {
    return {
      scene: null,
      bloomPass: null,
      cameraObj: null,
    };
  },
  watch: {
    menuActive: function (value) {
      const gridTarget = this.scene.children[0];
      const camera = gridTarget.children[0];
      // const xQuaternion = value ? -(Math.PI * 0.075) : 0;
      const xCoord = value ? 1.5 : 0;
      // const zCoord = value ? 2 : 0;
      const tl = this.gsap.timeline();
      const glowStrength = value ? 2 : 0;
      // const tl1 = this.gsap.timeline();
      // tl.to(gridTarget.position, {
      // 	duration: 1.15,
      // 	z: zCoord,
      // });

      console.log(this.cameraObj);
      tl.to(
        this.cameraObj.position,
        {
          duration: 1.15,
          z: xCoord,
          // y: zCoord,
        }
        // '-=1.15',
      );
      tl.to(
        this.bloomPass,
        {
          duration: 1.15,
          strength: glowStrength,
        },
        "-=1.15"
      );
    },
    $route() {
      const tl1 = this.gsap.timeline();
      tl1
        .to(this.bloomPass, {
          duration: 0.5,
          strength: 1,
        })
        .to(this.bloomPass, {
          duration: 1,
          strength: 0,
        });
    },
  },
  mounted() {
    const sceneTHREE = new THREE.Scene();
    this.scene = sceneTHREE;
    // Base camera
    const canvas = this.$refs.canvas;

    const sizes = {
      width: window.innerWidth,
      height: window.innerHeight,
    };
    //Renderer
    const renderer = new THREE.WebGLRenderer({
      canvas: canvas,
      alpha: true,
      antiAlias: true,
    });
    renderer.setSize(sizes.width, sizes.height);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    renderer.outputColorSpace = THREE.LinearSRGBColorSpace;
    renderer.toneMapping = THREE.ReinhardToneMapping;
    renderer.toneMappingExposure = Math.pow(0.8, 4.0);

    //Scene
    const scene = this.scene;

    //Camera
    const cameraGroup = new THREE.Group();

    const camera = new THREE.PerspectiveCamera(
      35,
      sizes.width / sizes.height,
      0.1,
      100
    );
    camera.position.z = 7;
    // scene.add(camera);
    // cameraGroup
    this.cameraObj = cameraGroup;
    this.cameraObj.add(camera);
    scene.add(this.cameraObj);

    // Update camera
    camera.aspect = sizes.width / sizes.height;
    camera.updateProjectionMatrix();

    // const particleTexture = textureLoader.load('/textures/particles/1.png');

    // Controls
    const controls = new OrbitControls(camera, canvas);
    controls.enableDamping = true;

    // const count = 5;
    // const particlegeo = new THREE.PlaneBufferGeometry(1, 10);
    // const geo = new THREE.InstancedBufferGeometry();
    // // const min_radius = 0.5;
    // // const max_radius = 2;
    // geo.instanceCount = count;
    // geo.setAttribute('position', particlegeo.getAttribute('position'));
    // geo.index = particlegeo.index;

    // let pos = new Float32Array(count * 3);

    // for (let i = 0; i < count; i++) {
    // 	// let angle = Math.random() * Math.PI * 2;
    // 	// let x = (Math.random() - 0.5) * 0.5;
    // 	// let y = (Math.random() - 0.5) * 0.5;
    // 	// let z = (Math.random() - 0.5) * 0.5;

    // 	let x = i * 0.5;
    // 	let y = 0;
    // 	let z = 0;

    // 	pos.set([x, y, z], i * 3);
    // }

    // geo.setAttribute(
    // 	'pos',
    // 	new THREE.InstancedBufferAttribute(pos, 3, false),
    // );

    // const material = new THREE.ShaderMaterial({
    // 	extensions: {
    // 		derivatives: '#extension GL_OES_standard_derivatives : enable',
    // 	},
    // 	side: THREE.DoubleSide,
    // 	uniforms: {
    // 		time: { value: 0 },
    // 		resolution: { value: new THREE.Vector4() },
    // 		uTexture: {
    // 			value: new THREE.TextureLoader().load(textureImage),
    // 		},
    // 	},
    // 	wireframe: true,
    // 	transparent: true,
    // 	// depthTest: false,
    // 	// vertexShader: vertex,
    // 	// fragmentShader: fragment,
    // });

    // // const geometry = new THREE.PlaneBufferGeometry(1, 1, 1, 1);
    // const points = new THREE.Line(geo, material);

    // scene.add(points);

    // const lineGeo = new THREE.PlaneBufferGeometry(0.015, 10);

    // const lineMat = new THREE.MeshBasicMaterial({
    // 	color: 'green',
    // 	transparent: true,
    // 	// opacity: 0.5,
    // });

    // for (let i = 0; i < 5; i++) {
    // 	const x = i * 3;
    // 	const line = new THREE.Mesh(lineGeo, lineMat);
    // 	line.position.set(x, 0, 0);
    // 	scene.add(line);
    // }

    const size = 100;
    const divisions = 70;

    const gridHelper = new THREE.GridHelper(size, divisions);
    gridHelper.rotation.x = Math.PI / 2;
    gridHelper.rotation.y = Math.PI / 2;
    // gridHelper.rotation.z = Math.PI / 1.4;
    gridHelper.material.opacity = 1;
    gridHelper.material.transparent = true;
    scene.add(gridHelper);

    window.addEventListener("resize", () => {
      sizes.width = window.innerWidth;
      sizes.height = window.innerHeight;

      //camera
      camera.aspect = sizes.width / sizes.height;
      camera.updateProjectionMatrix();

      // Update renderer
      renderer.setSize(sizes.width, sizes.height);
      renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

      composer.setSize(sizes.width, sizes.height);
    });

    let cursor = {
      x: 0,
      y: 0,
    };

    window.addEventListener("mousemove", (event) => {
      cursor.x = event.clientX / sizes.width - 0.5;
      cursor.y = event.clientY / sizes.height - 0.5;
    });

    //Light
    scene.add(new THREE.AmbientLight(0x404040));

    const pointLight = new THREE.PointLight(0xffffff, 1);
    this.cameraObj.add(pointLight);

    let composer;
    const renderScene = new RenderPass(scene, camera);
    this.bloomPass = new UnrealBloomPass(
      new THREE.Vector2(sizes.width, sizes.height),
      1.5,
      0.4,
      0.85
    );

    this.bloomPass.exposure = 1;
    this.bloomPass.threshold = 0;
    this.bloomPass.strength = 0;
    this.bloomPass.radius = 0.5;
    // bloomPass.renderToScreen = true;

    composer = new EffectComposer(renderer);

    composer.addPass(renderScene);
    composer.addPass(this.bloomPass);

    /**
     * Animate
     */
    const clock = new THREE.Clock();
    let previousTime = 0;

    const tick = () => {
      const elapsedTime = clock.getElapsedTime();
      const deltaTime = elapsedTime - previousTime;
      previousTime = elapsedTime;
      // Render
      // renderer.render(scene, camera);

      // camera.position.y = -scrollY / sizes.height;

      // this.gsap.to(camera.position, {
      // 	duration: 0.25,
      // 	y: -scrollY / sizes.height,
      // });
      const parallaxX = cursor.x * 0.25;
      const parallaxY = cursor.y * 0.25;

      this.cameraObj.position.x +=
        (parallaxX - this.cameraObj.position.x) * 5 * deltaTime;
      this.cameraObj.position.y +=
        (parallaxY - this.cameraObj.position.y) * 5 * deltaTime;

      composer.render();
      // Call tick again on the next frame
      window.requestAnimationFrame(tick);
    };
    tick();
  },
};
</script>

<style lang="scss">
.scene-overlay-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  background-color: black;
  overflow: hidden;

  // &:before {
  // 	content: ' ';
  // 	position: absolute;
  // 	top: 0;
  // 	left: 0;
  // 	width: 100%;
  // 	height: 100%;
  // 	background-image: url('../../assets/bedge-grunge.png');
  // 	background-repeat: repeat;
  // 	background-size: 100%;
  // 	background-size: 50px;
  // 	opacity: 0.2;
  // }

  #portfolio-canvas {
    position: absolute;
    top: 0;
    left: 0;
    outline: none;
    width: 100%;
    height: 100%;
  }
}
</style>
